var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.777419 0.454634C0.85371 0.37815 0.944341 0.317468 1.04412 0.276064C1.1439 0.23466 1.25087 0.213348 1.3589 0.213348C1.46692 0.213348 1.57389 0.23466 1.67367 0.276064C1.77345 0.317468 1.86408 0.37815 1.94037 0.454634L6.28667 4.80257L10.633 0.454634C10.7872 0.300417 10.9963 0.213778 11.2144 0.213778C11.4325 0.213778 11.6417 0.300417 11.7959 0.454634C11.9501 0.608852 12.0368 0.818015 12.0368 1.03611C12.0368 1.25421 11.9501 1.46337 11.7959 1.61759L6.86815 6.54536C6.79185 6.62185 6.70122 6.68253 6.60144 6.72393C6.50166 6.76533 6.3947 6.78665 6.28667 6.78665C6.17864 6.78665 6.07167 6.76533 5.97189 6.72393C5.87211 6.68253 5.78148 6.62185 5.70519 6.54536L0.777419 1.61759C0.700934 1.5413 0.640252 1.45067 0.598848 1.35089C0.557444 1.25111 0.536133 1.14414 0.536133 1.03611C0.536133 0.928083 0.557444 0.821115 0.598848 0.721336C0.640252 0.621556 0.700934 0.530926 0.777419 0.454634Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.0e745a18.svg";
export { ForwardRef as ReactComponent };